import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: ['Poppins', 'sans-serif'].join(','),
  h1: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: 1.33,
  },
  h2: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  h3: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '30px',
  },
  h5: {
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '18px',
  },
  h6: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '18px',
    fontWeight: 300,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  caption: {
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: '20px',
  },
  overline: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 'normal',
  },
};
